import React from 'react';
import Chart from 'react-apexcharts';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Panel, PanelBody, PanelHeader } from '../../components/panel/panel';

class doughnutChart extends React.PureComponent {
  static handleFormatter = (data) => {
    data.dataLabels = {
      formatter(value) {
        return `${parseInt(value, 10)}%`;
      },
    };
    data.legend = {
      formatter(value, opts) {
        return `${parseInt(opts.w.config.series[opts.seriesIndex], 10)} - ${value}`;
      },
    };
    return data;
  };

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {
    const { doughnutChartData } = this.props;
    return (
      <Panel>
        <PanelHeader onClickCollapse>
          {this.props.title}
        </PanelHeader>
        <PanelBody>
          <div style={{ height: `${this.props.height ? this.props.height : '450px'}` }}>
            {doughnutChartData
              && (
              <Chart
                series={doughnutChartData.series}
                options={doughnutChart.handleFormatter(doughnutChartData.options)}
                type="donut"
                height="100%"
              />
              )}
          </div>
        </PanelBody>
      </Panel>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withRouter(doughnutChart));
